"use client";
import { motion, useMotionValueEvent, useScroll } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";

export const StickyScroll = ({ content }) => {
  const [activeCard, setActiveCard] = useState(0);
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    container: ref,
    offset: ["start start", "end start"],
  });

  const cardLength = content.length;

  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    const cardsBreakpoints = content.map((_, index) => index / cardLength);
    const closestBreakpointIndex = cardsBreakpoints.reduce(
      (acc, breakpoint, index) => {
        const distance = Math.abs(latest - breakpoint);
        return distance < Math.abs(latest - cardsBreakpoints[acc])
          ? index
          : acc;
      },
      0
    );
    setActiveCard(closestBreakpointIndex);
  });

  const backgroundColors = [
    "var(--base_900)",
    "var(--violet-950)",
    "var(--yellow-950)",
    "var(--green-900)",
    "var(--blue-900)",
    "var(--rose-900)",
  ];

  const linearGradients = React.useMemo(
    () => [
      "linear-gradient(to bottom right, #0f172a, #1e293b)", // slate
      "linear-gradient(to bottom right, #4c1d95, #7c3aed)", // violet
       // yellow
      "linear-gradient(to bottom right, #065f46, #10b981)", // green
      "linear-gradient(to bottom right, #1e40af, #3b82f6)", // blue
      "linear-gradient(to bottom right, #881337, #f43f5e)", // rose
    ],
    []
  );

  const [backgroundGradient, setBackgroundGradient] = useState(
    linearGradients[0]
  );

  useEffect(() => {
    setBackgroundGradient(
      linearGradients[activeCard % linearGradients.length]
    );
  }, [activeCard, linearGradients]);

  return (
    <motion.div
      animate={{
        backgroundColor:
          backgroundColors[activeCard % backgroundColors.length],
      }}
      className="h-[45rem] overflow-y-auto scroll-smooth flex justify-center relative px-4 md:px-8 scrollbar-hide"
      ref={ref}
    >
      <div className="relative flex flex-col items-start w-full max-w-[90rem] mx-auto">
        {content.map((item, index) => (
          <div
            key={item.id}
            className="my-20 flex flex-col  justify-between gap-8"
          >
            {/* Left Content */}
            <div className="md:w-3/4 lg:w-2/4">
              <motion.h2
                initial={{ opacity: 0 }}
                animate={{
                  opacity: activeCard === index ? 1 : 0.3,
                }}
                className="text-2xl md:text-3xl font-bold text-white"
              >
                {item.year_range}
              </motion.h2>

              <motion.div
                initial={{ opacity: 0 }}
                animate={{
                  opacity: activeCard === index ? 1 : 0.3,
                }}
                className="text-sm md:text-lg text-slate-300 mt-4 "
              >
                <div
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              </motion.div>
            </div>
            <p className="text-lg font-semibold mt-4 text-white border-b border-slate-500 pb-1">Some of our milestone work</p>
            {/* Right Timeline Cards */}
            <div className="w-full md:w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
             
              {item.timelines.map((timeline) => (
                <div
                  key={timeline.id}
                  className="border border-slate-600 p-4 rounded-md shadow-lg bg-black/20 backdrop-blur-sm"
                >
                  <div className="w-full h-48 overflow-hidden rounded">
                    <img
                      src={timeline.image}
                      alt={timeline.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-lg font-semibold mt-4 text-white border-b border-slate-500 pb-1">
                    {timeline.title}
                  </h3>
                  <div
                    className="text-sm mt-2 text-slate-300"
                    dangerouslySetInnerHTML={{
                      __html: timeline.description,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
        {/* <div className="h-32" /> */}
      </div>
    </motion.div>
  );
};
